import { Checkbox } from '@mui/material';
import styled from 'styled-components';
import { COLORS } from 'theme/colors';

export const List = styled.ul`
  margin-right: 'auto';
`;

type ListRowAlignment = 'top' | 'center' | 'bottom';
export const ListRow = styled.li<{ align?: ListRowAlignment }>`
  display: flex;
  align-items: ${(props) => (props.align ? props.align : 'center')};
  margin-bottom: 0.4rem;
  min-height: 31px;
`;

export const ListRowTitle = styled.div`
  font-weight: 600;
  width: 45%;
  text-align: right;
  margin-right: 12px;
`;

export const ListRowData = styled.div`
  /* width: 30%; */
  text-align: left;
  display: flex;
  flex-direction: column;
`;

export const StyledCheckbox = styled(Checkbox)`
  && {
    padding: 0;
  }
`;

export const ErrorContainer = styled.div`
  width: 100px;
`;

export const Error = styled.p`
  color: ${COLORS.DARK_RED};
  font-size: 0.875rem;
  margin-left: 0.6rem;
`;
